<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="hanging" id="epig">If you are planning for the year, grow rice.</p>
<p class="hanging">If you are planning for the decade, grow trees.</p>
<p class="hanging">If you are planning for the centuries, grow men and women.<br/><br/></p>
<p class="right"><em>—Chinese Proverb</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062046253_epub_epig_r1.vue?262a7ca3